import '../sass/project.scss';

/* Project specific Javascript goes here. */
function getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]');
    return token ? token.getAttribute('content') : null;
}

$(document).ready(function() {
    function closeAlerts(event) {
        if (document.getElementById('alert')) {
            let alert = new Alert(document.getElementById('alert'));
            alert.close()
        }
        if (document.getElementsByClassName('alert')) {
            let alerts = document.getElementsByClassName('alert');
            for (let i = 0; i < alerts.length; i++) {
                let alert = new Alert(alerts[i]);
                alert.close()
            }
        }
    }
    $(document).on('click', closeAlerts);
});

export { getCSRFToken };
